module.exports = __webpack_public_path__ + "static/media/parenting_issues.747f977f.jpg";